import { createContext } from 'react';

export const LastLocationContext = createContext({});
LastLocationContext.displayName = 'LastLocationContext';
